import { PowerIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Logout = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <PowerIcon color={fill} size={Sizes[size]} {...rest} />;
};

Logout.displayName = 'Logout';
